import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderChurchFinder from "../../../../src/content/nn-church-finder/donationHeader";
import "../../../../src/content/nn-church-finder/church-finder.scss";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderChurchFinder,
  React
};